import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class ApprovalNoteAPI extends ComponentAPI {
    setData(data) {
        this.setState({ ...data });
    }
}
//# sourceMappingURL=approval-note-api.js.map